// Landing -> app hand-off values that must never reach a server.
//
// A pasted link can itself be an access key (Yandex Disk / Google Drive share
// ids, Zoom recording ids with `pwd=`). In the query string it would land in
// nginx access logs, Loki and crawler queues; the URL fragment is not sent in
// HTTP requests, so it goes there instead: `/app/transcriptions#transcribeUrl=<encoded>`.
// The app (transcripta-frontend) reads it from `location.hash` and removes it.
// Other hand-off params (guest, mode, preUploadId, locale, site_id, utm_*)
// stay in the query string.

export type HandoffFragmentParams = Record<string, string | null | undefined>;

/** Appends `#key=<encodeURIComponent(value)>&...` to `url` (replacing any existing fragment). */
export function withHandoffFragment(url: string, params: HandoffFragmentParams): string {
  const pairs = Object.entries(params)
    .filter((entry): entry is [string, string] => typeof entry[1] === "string" && entry[1] !== "")
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  const hashIndex = url.indexOf("#");
  const base = hashIndex === -1 ? url : url.slice(0, hashIndex);
  return pairs.length ? `${base}#${pairs.join("&")}` : base;
}
